export const UserRoles = {
  User: "customer",
  Admin: "state_manager",
  Sazman: "organization_manager",
  SazmanOstan: "state_organization_manager",
  ModireKol: "admin",
  UnKnown: "UnKnown",
};
